export default {
  methods: {
    reloadApp: function () {
      navigator.serviceWorker.getRegistrations().then(registrations => Promise.all(registrations.map(r => r.unregister()))).then(() => window.location.reload());
    },
    checkmarkCurrentTheme: function () {
      var self = this; //var color = app.utils.theme.getColor();
      //var layout = app.utils.theme.getLayout();
      //self.$('[name=theme-color][value=' + color + ']').prop('checked', true);
      //self.$('[name=theme-layout][value=' + layout + ']').prop('checked', true);
    },
    changeThemeColor: function (event) {
      var self = this;
      var color = event.target.value; //app.utils.theme.setColor(color);
    },
    changeThemeLayout: function (event) {
      var self = this;
      var app = self.$app;
      var layout = event.target.value; //app.utils.theme.setLayout(layout);

      app.$('body').removeClass('theme-light theme-dark');
      app.$('body').addClass('theme-' + layout);
    }
  },
  on: {
    pageInit: function () {
      var self = this;
      var app = self.$app;
      self.checkmarkCurrentTheme();
      self.$('[name=theme-color]').on('change', self.changeThemeColor);
      self.$('[name=theme-layout]').on('change', self.changeThemeLayout);
    }
  },
  id: 'cda54c3477',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n<div class="page">\n  <div class="navbar">\n    <div class="navbar-bg"></div>\n    <div class="navbar-inner sliding">\n      <div class="left">\n        <a href="#" class="link back">\n          <i class="icon icon-back"></i>\n          <span class="if-not-md">Back</span>\n        </a>\n      </div>\n      <div class="title">Settings</div>\n    </div>\n  </div>\n  <div class="page-content">\n    <div class="block-title">Layout</div>\n    <div class="list">\n      <ul>\n        <li>\n          <label class="item-radio item-content">\n            <input type="radio" name="theme-layout" value="light" />\n            <i class="icon icon-radio"></i>\n            <div class="item-media ios-only">\n              <i class="icon f7-icons color-gray-0">circle_fill</i>\n            </div>\n            <div class="item-inner">\n              <div class="item-title" data-i18n="light">Light</div>\n              <div class="item-after md-only">\n                <i class="icon material-icons color-gray-0">lens</i>\n              </div>\n            </div>\n          </label>\n        </li>\n        <li>\n          <label class="item-radio item-content">\n            <input type="radio" name="theme-layout" value="dark" />\n            <i class="icon icon-radio"></i>\n            <div class="item-media ios-only">\n              <i class="icon f7-icons color-black">circle_fill</i>\n            </div>\n            <div class="item-inner">\n              <div class="item-title" data-i18n="dark">Dark</div>\n              <div class="item-after md-only">\n                <i class="icon material-icons color-black">lens</i>\n              </div>\n            </div>\n          </label>\n        </li>\n      </ul>\n    </div>\n    <div class="list">\n      <ul>\n        <li>\n          <a href="#" class="item-link panel-close" @click="reloadApp">\n            <div class="item-content">\n              <div class="item-inner">\n                <div class="item-title" data-i18n="principles">Reload App</div>\n              </div>\n            </div>\n          </a>\n        </li>\n      </ul>\n    </div>\n  </div>\n</div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};